import React, { useContext, useEffect, useState } from "react";
import {Chart as ChartJS} from "chart.js/auto"
import { ContentContext } from "./context/ContentContext";
import { ChoosenDataSet} from "./context/ChoosenDataSet"
import { Chart, Line } from "react-chartjs-2";
import { NewAddDomain } from "./context/NewAddDomain";
import { DomainContext } from "./context/DomainNameContext";
import { AlertContext } from "./context/AlertContext";
import { toast, ToastContainer } from "react-toastify";
import { isMobile } from "react-device-detect";
import "./CSS/Graph.css"
let color=["rgb(3, 165, 245)","rgb(117, 245, 3)","rgb(255, 74, 3)","rgb(209, 165, 240)"]
const Graph = () => {
  const { cityData } = useContext(ContentContext)
  const { choosenData } = useContext(ChoosenDataSet)
  const {newAddDataSet}=useContext(NewAddDomain)
  const [dataset, setDataset] = useState()
  const [activated, setActivated] = useState();
  const [toBeActive, setToBeActive] = useState();
  const {domainUrl}=useContext(DomainContext)
  const [options, setOptions] = useState();
  const [sortActive, setSortActive] = useState();
  const [labelArr, setLableArr] = useState();
  const {getAlert}=useContext(AlertContext)
  // const [disable, setDisable] = useState();
  // if (cityData) {
  //   console.log(cityData["dataList"][Object.keys(cityData["dataList"])[0]])
  // }
  // console.log(cityData);
  useEffect(() => {
    if (choosenData && newAddDataSet==undefined && !isMobile) {
      // console.log("insider selected")
        let arrActivated = [];
        let arrDisabled=[]
        let idx=-1
        for (let i = 0; i < choosenData.length; i++){
          if(choosenData[i].name == "Satellite True Color (10m)" || choosenData[i].name =="Satellite False Color (10m)" || choosenData[i].name=="Power Plant Locations" || choosenData[i].name=="Palm Oil Plantation Types" || choosenData[i].name=="Fire Radiative Power"){
            continue

          }
          arrActivated.push(i);
          if (arrActivated.length >= 4) {
            idx=i+1
            break;
          }
        }
        if (idx != -1 && idx < choosenData.length) {
          for (let i = idx; i < choosenData.length; i++){
            arrDisabled.push(i);
          }
        }
        setActivated(arrActivated);
        // setDisable(arrDisabled)
      setToBeActive();
    }
    else if (choosenData && newAddDataSet!=undefined && !isMobile) {
      // console.log("insider selected")
        let arrActivated = [];
        let arrDisabled=[]
        let idx=-1
        for (let i = 0; i < newAddDataSet.length; i++){
          if(newAddDataSet[i].name == "Satellite True Color (10m)" || newAddDataSet[i].name =="Satellite False Color (10m)" || newAddDataSet[i].name=="Power Plant Locations" || newAddDataSet[i].name=="Palm Oil Plantation Types" || newAddDataSet[i].name=="Fire Radiative Power"){
            continue

          }
          arrActivated.push(i);
          if (arrActivated.length >= 4) {
            idx=i+1
            break;
          }
        }
        if (idx != -1 && idx < newAddDataSet.length) {
          for (let i = idx; i < newAddDataSet.length; i++){
            arrDisabled.push(i);
          }
        }
        setActivated(arrActivated);
        // setDisable(arrDisabled)
      setToBeActive();
    }
    else if (choosenData && newAddDataSet==undefined && isMobile) {
      let arrActivated = [];
        let arrDisabled=[]
        let idx=-1
        for (let i = 0; i < choosenData.length; i++){
          if(choosenData[i].name == "Satellite True Color (10m)" || choosenData[i].name == "Satellite False Color (10m)" || choosenData[i].name=="Power Plant Locations" || choosenData[i].name=="Palm Oil Plantation Types" || choosenData[i].name=="Fire Radiative Power"){
            continue

          }
          arrActivated.push(i);
          if (arrActivated.length >= 2) {
            idx=i+1
            break;
          }
        }
        if (idx != -1 && idx < choosenData.length) {
          for (let i = idx; i < choosenData.length; i++){
            arrDisabled.push(i);
          }
        }
        setActivated(arrActivated);
        // setDisable(arrDisabled)
      setToBeActive();
    }
    else if (choosenData && newAddDataSet!=undefined && isMobile) {
      let arrActivated = [];
        let arrDisabled=[]
        let idx=-1
        for (let i = 0; i < newAddDataSet.length; i++){
          if(newAddDataSet[i].name == "Satellite True Color (10m)" || newAddDataSet[i].name == "Satellite False Color (10m)" || newAddDataSet[i].name=="Power Plant Locations" || newAddDataSet[i].name=="Palm Oil Plantation Types" || newAddDataSet[i].name=="Fire Radiative Power"){
            continue

          }
          arrActivated.push(i);
          if (arrActivated.length >= 2) {
            idx=i+1
            break;
          }
        }
        if (idx != -1 && idx < newAddDataSet.length) {
          for (let i = idx; i < newAddDataSet.length; i++){
            arrDisabled.push(i);
          }
        }
        setActivated(arrActivated);
        // setDisable(arrDisabled)
      setToBeActive();
    }
  }, [ choosenData,domainUrl,newAddDataSet])
  const checkDataset = (index) => {
    if (!isMobile) {
       if (activated.length == 4) {
          getAlert(true);
        }
        else if (activated.length < 4) {
          setActivated([...activated, index])
          if (toBeActive.length > 1) {
            setToBeActive(toBeActive.filter(x=>x!=index))
          }
          else {
            setToBeActive();
          }
        }
    }
    else {
      if (activated.length == 2) {
       getAlert(true);
     }
     else if (activated.length < 2) {
       setActivated([...activated, index])
       if (toBeActive.length > 1) {
         setToBeActive(toBeActive.filter(x=>x!=index))
       }
       else {
         setToBeActive();
       }
     }
    }
  }
  useEffect(() => {
    if (cityData !== undefined && activated!==undefined) {
      // console.log(new Date(+cityData.timestamp[0]));
      let selectedData = [];
      if (newAddDataSet == undefined) {
        for (let i = 0; i < choosenData.length; i++){
          let present = false;
          for (let j = 0; j < activated.length; j++){
            if (activated[j] == i) {
              present = true;
              break;
            }
          }
          if (present == true) {
            selectedData.push(choosenData[i].name)
          }
          
        }
      }
      else if (newAddDataSet != undefined) {
        for (let i = 0; i < newAddDataSet.length; i++){
          let present=false
          for (let j = 0; j < activated.length; j++){
            if (activated[j] == i) {
              present = true;
              break;
            }
          }
          if (present == true) {
            selectedData.push(newAddDataSet[i].name)
          }
        }
      }
      const obj = {};
      for (let key in cityData.dataList) {
        // console.log(cityData.dataList[key])
        if (cityData.dataList[key] == "Satellite True Color (10m)" || cityData.dataList[key] == "Satellite False Color (10m)" || cityData.dataList[key]=="Power Plant Locations" || cityData.dataList[key]=="Palm Oil Plantation Types" || cityData.dataList[key]=="Fire Radiative Power") {
          continue
        }
        for (let x in cityData.dataList[key]) {
          if (x == "Satellite True Color (10m)" || x=="Satellite False Color (10m)" || x=="Power Plant Locations" || x=="Palm Oil Plantation Types" || x=="Fire Radiative Power") {
            continue
          }
          else if (selectedData.includes(x)==false) {
            continue
          }
          else {
            let value = 0;
            if (cityData.dataList[key][x].mean !== "none" || cityData.dataList[key][x].mean !== null) {
                value=cityData.dataList[key][x].mean
              }
            if (obj[x] == undefined) {
              // console.log(x)
              obj[x]=[value]
            }
            else {
              obj[x]=[...obj[x],value]
            }
          }
        }
      }
      let dataSetArr = [];
      let color=["rgb(3, 165, 245)","rgb(117, 245, 3)","rgb(255, 74, 3)","rgb(209, 165, 240)"]
      let indexCol = 0
      let labelArr = [];
      for (let x in obj) {
        // console.log(x)
        let smallObj = {
          label: x,
          data: obj[x],
          borderColor: color[indexCol],
          backgroundColor: color[indexCol],
          yAxisID: `${indexCol}`,
        };
        indexCol++;
        dataSetArr.push(smallObj);
      }
      for (let i = 0; i < dataSetArr.length; i++){
        labelArr.push(dataSetArr[i].label);
      }
      // console.log(dataSetArr)
      // console.log(labelArr)
      setLableArr(labelArr)
      setDataset({
        labels: cityData.timestamp.map((el) => {
          let date = new Date(+el * 1000);
          let day = date.getDate();
          let month=date.toLocaleString('default', {
            month:'short'
          })
          let year = date.getFullYear();
          return (day+"-"+month+"-"+year)
        }),
        datasets: dataSetArr,
        
      })
    }
    // console.log("inside activated useEffect")
    // console.log(newAddDataSet)
    if (activated !== undefined && activated.length < 4 && newAddDataSet==undefined) {
      let arr = [];
      for (let i = 0; i < choosenData.length; i++){
        let present=false
        for (let j = 0; j < activated.length; j++){
          if (i == activated[j]) {
            present = true;
            break;
          }
        }
        if (present == false) {
          arr.push(i)
        }
      }
      setToBeActive(arr);
      // setDisable();
    }
    else if(activated !== undefined && activated.length < 4 && newAddDataSet!=undefined) {
      let arr = [];
      for (let i = 0; i < newAddDataSet.length; i++){
        let present=false
        for (let j = 0; j < activated.length; j++){
          if (i == activated[j]) {
            present = true;
            break;
          }
        }
        if (present == false) {
          arr.push(i)
        }
      }
      setToBeActive(arr);
    }
    
  }, [activated, cityData, choosenData, newAddDataSet, domainUrl])
  // console.log(activated);
  // console.log(toBeActive);
  useEffect(() => {
    if (activated !== undefined) {
      setSortActive(activated.sort((a, b) => a - b))
    }
    
  }, [activated])
  useEffect(()=>{
    // console.log(choosenData)
    // console.log(sortActive)
    let config = {
  type: 'line',
    data: dataset,
    options: {
      responsive: true,
      maintainAspectRatio: false,
  // interaction: {
  //   mode: "index",
  //   intersect: true
  // },
  // stacked: false,
  plugins: {
    title: {
      display: false,
      text: "Chart.js Line Chart - Multi Axis"
    },
    tooltip: {
      yAlign: "bottom",
      callbacks: {
        label: function (context) {
          console.log(context)
          let b;
          if (context.raw.toString().includes("0.000") || +context.raw > 999) {
            b=(+context.raw).toExponential(3).includes("e-") == true ? (+context.raw).toExponential(3).toString().replace("e-", "x 10^- ") : (+context.raw).toExponential(3).includes("e+") == true && (+context.raw).toExponential(3).toString().replace("e+", "x 10^")
          }
          else {
            b = (+context.raw).toFixed(4);
          }
          // const a = context.raw.toExponential(3).includes("e-") == true ? context.raw.toExponential(3).toString().replace("e-", "x 10^- ") : context.raw.toExponential(3).includes("e+") == true && context.raw.toExponential(3).toString().replace("e+", "x 10^");
          return (context.dataset.label+" : "+b)
        },
      }
    },
    legend: {
      position: "top",
      display: true,
      labels: {
        color: "rgb(228, 232, 240)",
        padding: 20,
      }
      },
  },
      
  scales: {
    x: {
      ticks: {
        color: "rgb(228, 232, 240)",
        padding: 20,
      },
      border: {
        color: "rgb(153, 182, 242)",
        width:1
      }
    },
    0: {
      type: "linear",
      display: labelArr && labelArr.length>=1 ?true:false,
      position: "left",
      title: {
        display: true,
        color: color[0],
        // text: activated != undefined && activated.length >= 1 && newAddDataSet == undefined ? choosenData[sortActive[0]].name : activated != undefined
        // && activated.length>=1 && newAddDataSet !== undefined ? newAddDataSet[sortedActivate[0]].name:"",
        // text: activated != undefined && sortedActivate.length >= 1 && newAddDataSet == undefined ? choosenData[sortedActivate[0]].name :
        //   activated!=undefined && sortedActivate.length >= 1 && newAddDataSet ? newAddDataSet[sortedActivate[0]].name:"",
        text: labelArr && labelArr.length>=1 && cityData!=undefined && cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[0]].unit =="none"?labelArr[0]:labelArr && labelArr.length>=1 && cityData!=undefined && cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[0]].unit !=="none" &&labelArr[0]+" ("+ cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[0]].unit+")",
        padding:10
      },
      ticks: {
        padding: 8,
        color: color[0],
      },
      grid: {
        color: "rgb(23, 45, 89)",
        // tickWidth: 3,
        // tickLength:15
      },
      border: {
        color: "rgb(153, 182, 242)",
        width:1
      }
    },
    1: {
      type: "linear",
      display: labelArr && labelArr.length>=2 ?true:false,
      position: "right",
      title: {
        display: true,
        color: color[1],
        // text:activated != undefined && activated.length >= 2 && newAddDataSet == undefined ? choosenData[sortedActivate[1]].name : activated != undefined
        // && activated.length>=2 && newAddDataSet!=undefined ? newAddDataSet[sortedActivate[1]].name:"",
        // text: activated != undefined && sortedActivate.length >= 2 && newAddDataSet == undefined ? choosenData[sortedActivate[1]].name :
        //   activated!=undefined && sortedActivate.length >= 2 && newAddDataSet ? newAddDataSet[sortedActivate[1]].name:"",
        text: labelArr && labelArr.length>=2 && cityData!=undefined && cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[1]].unit =="none"?labelArr[1]:labelArr && labelArr.length>=2 && cityData!=undefined && cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[1]].unit !=="none" &&labelArr[1]+" ("+ cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[1]].unit+")",
        padding:10
      },
      ticks: {
        padding: 8,
        color:color[1]
      },
      grid: {
        drawOnChartArea: false,
        color: color[1],
        // tickWidth: 3,
        // tickLength:15
      },
       border: {
        color: "rgb(153, 182, 242)",
        width:1
      }
    },
    2: {
      type: "linear",
      display: labelArr && labelArr.length>=3 ?true:false,
      position: "right",
      grid: {
        drawOnChartArea: false,
        color: color[2],
        // tickWidth: 3,
        // tickLength:15
      },
      title: {
        display: true,
        color: color[2],
        // text: activated != undefined && activated.length >= 3 && newAddDataSet == undefined ? choosenData[sortedActivate[2]].name : activated != undefined
        // && activated.length>=3 && newAddDataSet!=undefined ? newAddDataSet[sortedActivate[2]].name:"",
        // text: activated != undefined && sortedActivate.length >= 3 && newAddDataSet == undefined ? choosenData[sortedActivate[2]].name :
        //   activated!=undefined && sortedActivate.length >= 3 && newAddDataSet ? newAddDataSet[sortedActivate[2]].name:"",
        text: labelArr && labelArr.length>=3 && cityData!=undefined && cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[2]].unit =="none"?labelArr[2]:labelArr && labelArr.length>=3 && cityData!=undefined && cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[2]].unit !=="none" &&labelArr[2]+" ("+ cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[2]].unit+")",
        padding:10
      },
      ticks: {
        padding: 8,
        color:color[2]
      },
       border: {
        color: "rgb(153, 182, 242)",
        width:1
      }
    },
    3: {
      type: "linear",
      display: labelArr && labelArr.length==4 ?true:false,
      position: "left",
      grid: {
        drawOnChartArea: false,
        color: color[3],
        // tickWidth: 3,
        // tickLength:15
      },
      title: {
        display: true,
        color: color[3],
        // text: newAddDataSet == undefined && sortActive && choosenData && sortActive.length == 4 ? choosenData[sortActive[3]]==undefined?"":choosenData[sortActive[3]].name : newAddDataSet != undefined && choosenData && sortActive &&
        // sortActive.length == 4 ?newAddDataSet[sortActive[3]]==undefined?"":newAddDataSet[sortActive[3]].name:"" ,
        text: labelArr && labelArr.length==4 && cityData!=undefined && cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[3]].unit =="none"?labelArr[3]:labelArr && labelArr.length==4 && cityData!=undefined && cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[3]].unit !=="none" &&labelArr[3]+" ("+ cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[3]].unit+")",
        padding:10
      },
      ticks: {
        padding: 8,
        color:color[3]
      },
       border: {
        color: "rgb(153, 182, 242)",
        width:1
      }
    },
    }
  
  }
    };
    let configMob = {
  type: 'line',
    data: dataset,
    options: {
      responsive: true,
      maintainAspectRatio: false,
  // interaction: {
  //   mode: "index",
  //   intersect: true
  // },
  // stacked: false,
  plugins: {
    title: {
      display: false,
      text: "Chart.js Line Chart - Multi Axis"
    },
    tooltip: {
      yAlign: "bottom",
      callbacks: {
        label: function (context) {
          let b;
          if (context.raw.toString().includes("0.000") || +context.raw > 999) {
            b=(+context.raw).toExponential(3).includes("e-") == true ? (+context.raw).toExponential(3).toString().replace("e-", "x 10^- ") : (+context.raw).toExponential(3).includes("e+") == true && (+context.raw).toExponential(3).toString().replace("e+", "x 10^")
          }
          else {
            b = (+context.raw).toFixed(4);
          }
          // const a = context.raw.toExponential(3).includes("e-") == true ? context.raw.toExponential(3).toString().replace("e-", "x 10^- ") : context.raw.toExponential(3).includes("e+") == true && context.raw.toExponential(3).toString().replace("e+", "x 10^");
          return (context.dataset.label+" : "+b)
        },
      }
    },
    legend: {
      position: "top",
      display: true,
      labels: {
        color: "rgb(228, 232, 240)",
        padding:30
      }
      },
  },
  scales: {
    x: {
      ticks: {
        color: "rgb(228, 232, 240)",
        padding: 4,
      },
      border: {
        color: "rgb(153, 182, 242)",
        width:1
      }
    },
    0: {
      type: "linear",
      display: labelArr && labelArr.length>=1 ?true:false,
      position: "left",
      title: {
        display: true,
        color: color[0],
        // text: activated != undefined && activated.length >= 1 && newAddDataSet == undefined ? choosenData[sortActive[0]].name : activated != undefined
        // && activated.length>=1 && newAddDataSet !== undefined ? newAddDataSet[sortedActivate[0]].name:"",
        // text: activated != undefined && sortedActivate.length >= 1 && newAddDataSet == undefined ? choosenData[sortedActivate[0]].name :
        //   activated!=undefined && sortedActivate.length >= 1 && newAddDataSet ? newAddDataSet[sortedActivate[0]].name:"",
        text: labelArr && labelArr.length>=1 && cityData!=undefined && cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[0]].unit =="none"?labelArr[0]:labelArr && labelArr.length>=1 && cityData!=undefined && cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[0]].unit !=="none" &&labelArr[0]+" ("+ cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[0]].unit+")",
        padding:4
      },
      ticks: {
        padding: 4,
        color: color[0],
      },
      grid: {
        color: "rgb(23, 45, 89)",
        // tickWidth: 3,
        // tickLength:15
      },
      border: {
        color: "rgb(153, 182, 242)",
        width:1
      }
    },
    1: {
      type: "linear",
      display: labelArr && labelArr.length==2 ?true:false,
      position: "right",
      title: {
        display: true,
        color: color[1],
        // text:activated != undefined && activated.length >= 2 && newAddDataSet == undefined ? choosenData[sortedActivate[1]].name : activated != undefined
        // && activated.length>=2 && newAddDataSet!=undefined ? newAddDataSet[sortedActivate[1]].name:"",
        // text: activated != undefined && sortedActivate.length >= 2 && newAddDataSet == undefined ? choosenData[sortedActivate[1]].name :
        //   activated!=undefined && sortedActivate.length >= 2 && newAddDataSet ? newAddDataSet[sortedActivate[1]].name:"",
        text: labelArr && labelArr.length == 2 && cityData != undefined && cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[1]].unit == "none" ? labelArr[1] : labelArr && labelArr.length == 2 && cityData != undefined && cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[1]].unit !== "none" && labelArr[1] + " (" + cityData["dataList"][Object.keys(cityData["dataList"])[0]][labelArr[1]].unit + ")",
        padding:4
      },
      ticks: {
        padding: 4,
        color:color[1]
      },
      grid: {
        drawOnChartArea: false,
        color: color[1],
        // tickWidth: 3,
        // tickLength:15
      },
       border: {
        color: "rgb(153, 182, 242)",
        width:1
      }
    },
      }
    }
    };
    if(!isMobile ? setOptions(config):setOptions(configMob))
    ;
  },[sortActive])
  // console.log(choosenData);
  // console.log(newAddDataSet)
  const notify = () => toast.error('You can not remove all datasets', {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme:"dark",
  });
  function changeFontsSize() {
    // console.log(window.outerWidth)
    if (window.outerWidth > 999) {
      ChartJS.defaults.font.size = 14
    }
    else if (window.outerWidth <= 999 && window.outerWidth > 500) {
      ChartJS.defaults.font.size = 10
    }
    else if(isMobile) {
      ChartJS.defaults.font.size = 9
    }
    // ChartJS.update();
  }
  useEffect(() => {
    if (ChartJS) {
      changeFontsSize();
    }
  },[])
  window.addEventListener("resize",changeFontsSize)
  return <div >
    <div className="datasetButton-div" >
      {choosenData && newAddDataSet == undefined ? choosenData.map((el, index) => {
        // console.log(choosenData);
        return <div
          id={`${(el.name == "Satellite True Color (10m)" || el.name == "Satellite False Color (10m)" || el.name=="Power Plant Locations" || el.name=="Palm Oil Plantation Types" || el.name=="Fire Radiative Power") && "not-shown"}`}
          className="datasetSelect">
          {<button
            onClick={() => {
              if (activated.includes(index)) {
                if (activated.length <= 1) {
                  notify();
                }
                else {
                  setActivated(activated.filter(x => x != index))
                }
                
              }
              if (activated.includes(index) == false) {
                checkDataset(index)
              }
            }}
            className={`${activated && activated.includes(index) ? "selected" : "not-selected"}`}
          >{el.name}</button>}
        </div>
      }) : newAddDataSet != undefined && newAddDataSet.map((el, index) => {
        // console.log(newAddDataSet);
        return <div id={`${(el.name == "Satellite True Color (10m)" || el.name == "Satellite False Color (10m)" || el.name=="Power Plant Locations" || el.name=="Palm Oil Plantation Types" || el.name=="Fire Radiative Power") && "not-shown"}`} className="datasetSelect">
          <button
            onClick={() => {
              if (activated.includes(index)) {
                if (activated.length <= 1) {
                  notify();
                }
                else {
                  setActivated(activated.filter(x => x != index))
                }
              }
              if (activated.includes(index) == false) {
                checkDataset(index)
              }
            }}
            className={`${activated && activated.includes(index) ? "selected" : "not-selected"}`}
          >{el.name}</button>
        </div>
      })}
      
    </div>
    <div className={`${!isMobile?"chart":"chart-mob"}`}>
      {dataset !== undefined && options && <Line
      data={dataset}
      options={ options.options} />}
    </div>
    <div style={{textAlign:"center",color:"gold",marginTop:"20px"}}>Note : <span style={{color:"white"}}>All plotted values in the graph are "area means" for the region shown in the map</span></div>
  </div>;
}
export default Graph